import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const PencilIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" fill="currentColor" {...props}>
    <path d="M13.5 3.7a1.2 1.2 0 0 0-2-1V3l-1 1 1.7 1.7 1-1 .3-.9Zm-10 7-.1.3-.7 2.3 2.3-.7.2-.1 6-6-1.7-1.7-6 6Zm11.3-7c0 .6-.2 1.2-.5 1.6l-.2.2L12.7 7l-.1.1-6.4 6.4a2 2 0 0 1-.8.5l-3 .9a1 1 0 0 1-1.2-1.3l.9-2.9.4-.7L9 3.3l1.5-1.5a2.5 2.5 0 0 1 4.3 1.8Z" />
  </Icon>
));
export default PencilIcon;
